module.exports = __webpack_public_path__ + "img/组 4.b0bcc288.png";